import React from 'react';
import EnterpriseDashboard from '../../components/enterprise/EnterpriseDashboard';

const EnterpriseDashboardPage = () => {
  return (
    <div>
      <EnterpriseDashboard />
    </div>
  );
};

export default EnterpriseDashboardPage;
